import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import Svg from '@r1-frontend/ui-react/components/svg/Svg';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { EStepperSizes } from './index';
import Stepper, { StepperProps } from './Stepper';

export const Control = styled.div<{ $transparency?: boolean }>`
    display: inline-block;
    cursor: pointer;
    opacity: ${({ $transparency }) => $transparency ? '0.2' : '1'};
    pointer-events: ${({ $transparency }) => $transparency ? 'none' : 'inherit'};
    color: inherit;
    height: 20px;
`;

export const StyledStepper = styled(Stepper)<StepperProps>`
    display: block;
    box-sizing: border-box;
    padding: 0 12px;
    border-radius: 20px;

    background: ${({ $bgColor = COLORS.TextWhite }) => $bgColor};

    height: ${({ $size = 'medium' }) => EStepperSizes[$size]}px;

    @media (min-width: ${wideBreakpoints.mobile}) {
        display: inline-block;
    }

    & :nth-child(2) {
        display: inline-block;
        min-width: 20px;
        text-align: center;
        ${FONTS.XS};
        color: ${({ $color = COLORS.TextPrimary }) => $color};
        margin: 0 8px;
    }

    & ${Svg} #guts {
        stroke: ${({ $color = COLORS.TextPrimary }) => $color};
    }

    user-select: none;

    &[data-disabled=true] {
        pointer-events: none;
        background-color: ${COLORS.Disabled};
        color: ${COLORS.GRAY_DARK};
    }
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
`;

